import { render, staticRenderFns } from "./PaymentTypeTypeSelectbox.vue?vue&type=template&id=3e4062d6&"
import script from "./PaymentTypeTypeSelectbox.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeTypeSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports